<template>
  <div class="dataview">
    <div class="left">

      <el-input v-model="searchVeg" placeholder="搜索蔬菜" @input="handleSearchv" ></el-input>
      <div class="left_item">
        <el-menu
          class="el-menu-vertical-demo"
        >
        <el-menu-item-group v-for="(type,typeindex) in vegetype" v-show="(filteredVegetable[typeindex].length>0)">
          <span slot="title">{{type}}</span>
           <el-menu-item v-for="(item, index) in filteredVegetable[typeindex]" :index="index" @click="handleSelectv(type,item)" :class="{elitem_active:item==activevegetable}">
            <template slot="title">
              {{ item }}
            </template>
          </el-menu-item>
        </el-menu-item-group>

        </el-menu>
      </div> 
 


       <el-input  v-model="searchPro"  placeholder="搜索省份"  @input="handleSearchp"></el-input>
      <div class="left_item">
      <el-menu
        class="el-menu-vertical-demo"
        @select="handleSelectp"
      >
        <el-menu-item v-for="(item, index) in filteredProvinces" :index="index" :class="{elitem_active:item==activeprovince}">
          <template slot="title">
            {{ item }}
          </template>
        </el-menu-item>
      </el-menu></div>
      
      
    </div>
    <div class="rightline" v-loading="loading">
      <div style="position: absolute;top:0;width:100%" >
          <span style="font-size: 2.6vh;font-weight: 600;margin-right:1vh">{{activeprovince}}</span>
          <span style="font-size: 2.6vh;font-weight: 600;margin-left:1vh"">{{activevegetable}}</span>
          
      </div>
      <div style="position: absolute;top:0;right:1%" @click="dialogTableVisible = true">数据下载</div>
      <LineView :data="this.linedata" :provice="this.activeprovince" :vegetable="this.activevegetable" />
    </div>
    <el-dialog title="数据下载" :visible.sync="dialogTableVisible">
      <div style="max-height:60vh;overflow-y:auto">
        <div style="display:flex;">
           <el-input v-model="searchVeg2" placeholder="搜索蔬菜" @input="handleSearchv2" style="width:30%"></el-input>
           
           <el-input  v-model="searchPro2"  placeholder="搜索省份"  @input="handleSearchp2" style="width:30%"></el-input>
           <div style="display:flex;align-items:center;width:40%">
           <el-date-picker 
              v-model="dateList[0]"
              type="year"
              placeholder="选择开始年"
              :size="size"
              class="year-picker"
              format="yyyy"
              value-format="yyyy"
              :picker-options="startDatePicker"
            >
            </el-date-picker>
            <span class="range-word"> 至 </span>
            <el-date-picker 
              v-model="dateList[1]"
              type="year"
              placeholder="选择结束年"
              :size="size"
              class="year-picker"
              format="yyyy"
              value-format="yyyy" 
              :picker-options="endDatePicker"
            >
            </el-date-picker></div>
           <el-button @click="searchvegpro()">搜索</el-button>
        </div>
              
        <el-table :data="searchdata"   stripe>
          <el-table-column property="date"    prop="年份"           label="年份"          > </el-table-column>
          <el-table-column property="name"    prop="种类"           label="种类"          ></el-table-column>
          <el-table-column property="address" prop="省份"           label="省份"          ></el-table-column>
          <el-table-column property="address" prop="单位面积碳碳足迹" label="单位面积碳碳足迹"></el-table-column>
          <el-table-column property="address" prop="单位产量碳碳足迹" label="单位产量碳碳足迹"></el-table-column>
        </el-table>
        <div @click="exportExcel()">下载 </div>
      </div>
      
    </el-dialog>
  </div>
</template>

<script>
import LineView from "@/components/line.vue";
import XLSX from 'xlsx';
export default {
  data() {
    return {
      startDatePicker: this.beginDate(),
      endDatePicker: this.processDate(),
      dateList:['',''],
      dialogTableVisible:false,
      vegetype:['主粮','蔬菜','林果','糖料','油料','烟叶','纤维','大豆'],
      vegetypeitems: [
      ['小麦','玉米','水稻-早籼稻','水稻-中籼稻','水稻-晚籼稻','水稻-粳稻'],
      ["马铃薯","菜花", "大白菜", "豆角", "露地菜椒", "露地黄瓜", "露地茄子", "露地西红柿", "萝卜", "设施菜椒", "设施黄瓜", "设施茄子", "设施西红柿", "圆白菜"],
      ['苹果','柑','橘'],
      ['甘蔗','甜菜'],
      ['花生','油菜'],
      ['烤烟','晾晒烟'],
      ['桑蚕丝','棉花'],
      ['大豆']],
      vegetypeitem: [
      ['小麦','玉米','水稻-早籼稻','水稻-中籼稻','水稻-晚籼稻','水稻-粳稻'],
      ["马铃薯","菜花", "大白菜", "豆角", "露地菜椒", "露地黄瓜", "露地茄子", "露地西红柿", "萝卜", "设施菜椒", "设施黄瓜", "设施茄子", "设施西红柿", "圆白菜"],
      ['苹果','柑','橘'],
      ['甘蔗','甜菜'],
      ['花生','油菜'],
      ['烤烟','晾晒烟'],
      ['桑蚕丝','棉花'],
      ['大豆']],
      vegetableList:['露地西红柿','豆角','菜花','大白菜'],
      searchPro: "",
      searchVeg: "",
      searchPro2: "",
      searchVeg2: "",
      loading:true,
      // 用于存储过滤后的省份列表
      filteredProvinces: [],
      filteredVegetable: [],
      activeIndexp: 0,
      activeIndexv: 0,
      allprovincesData: [],
      linedata: [],
      activeprovince: "平均",
      activevegetable:"小麦",
      activevegetype:'主粮',
      provincesList:[],
      searchdata:[],
      params:[]
    };
  },
  name: "DataView",
  components: {
    LineView,
  },
  mounted() {
    this.filteredVegetable=this.vegetypeitem
    // this.getvegetable()
     console.log(this.$route.query)
    console.log(Object.keys(this.$route.query).length > 0)
    var query= this.$route.query
    if(Object.keys(query).length > 0){
      this.activevegetable= query.vegetable
      this.activevegetype=query.vegetype
      this.activeprovince=query.provicesdata
    }
     this.getdatabyprovice();
    console.log(this.activevegetable);
  },
  methods: {

    handleSearchp() {
      // 根据搜索框输入内容过滤省份列表
      this.filteredProvinces = this.provincesList.filter(province =>
        province.includes(this.searchPro.trim())
      );
       if(this.searchVeg.trim()==''||this.searchVeg==null){
      
        console.log(this.provincesList)
        console.log(this.filteredProvinces)
      }
      // 查找匹配省份在原省份列表中的索引
      // const matchIndex = this.provincesList.findIndex(province =>
      //   province === this.searchPro
      // );
      // if (matchIndex!== -1) {
      //   // 设置当前激活的菜单项索引，用于滚动条定位
      //   this.activeIndexp = matchIndex.toString();
      //   // 获取el-menu实例
      //   const menu = this.$refs.menuRef;
      //   // 调用el-menu的滚动到指定索引的方法
      //   menu.setCurrentKey(this.activeIndexp);
      // }
    },
    handleSearchv() {
      console.log(this.searchVeg)
      for(var i=0;i<this.vegetype.length;i++){
        this.filteredVegetable[i]=this.vegetypeitem[i].filter(vegetable =>
          vegetable.includes(this.searchVeg.trim())
        )
      }

      if(this.searchVeg.trim()==''||this.searchVeg==null){
        
        this.filteredVegetable=JSON.parse(JSON.stringify(this.vegetypeitems))
        this.vegetypeitem=JSON.parse(JSON.stringify(this.vegetypeitems))
        // console.log(this.filteredVegetable)
        console.log(this.vegetypeitem)
        console.log(this.vegetype)
        console.log(this.vegetypeitems)
      }
      // this.filteredVegetable = this.vegetableList.filter(vegetable =>
      //   vegetable.includes(this.searchVeg)
      // );
       
      // 查找匹配省份在原省份列表中的索引
      // const matchIndex = this.vegetableList.findIndex(vegetable =>
      //   vegetable === this.searchVeg
      // );
      // if (matchIndex!== -1) {
      //   // 设置当前激活的菜单项索引，用于滚动条定位
      //   this.activeIndexv = matchIndex.toString();
      //   // 获取el-menu实例
      //   const menu = this.$refs.menuRef;
      //   // 调用el-menu的滚动到指定索引的方法
      //   menu.setCurrentKey(this.activeIndexv);
      // }
    },
    getdatabyprovice() {
      this.loading=true
      this.$axios.get("/api/getdatabypv/?type="+this.activevegetype+'&&vege='+this.activevegetable).then((res) => {
        console.log(res.data);
        this.allprovincesData = res.data;
        this.provincesList=Object.keys(res.data)
        this.filteredProvinces=Object.keys(res.data)
        this.changedata()
        console.log(this.linedata);
        this.loading=false
      });
    },
    // updataline(key){
    //   console.log(key)
    //   this.activeprovince=this.provincesList[key]
    //   this.linedata=this.allprovincesData[this.activeprovince].data
    //   console.log(this.linedata)
    // },
    handleSelectp(key) {
      console.log(key);
      this.activeprovince = this.filteredProvinces[key];
      this.changedata()
    },
    handleSelectv(type,item) {
      this.activevegetype=type
      this.activevegetable = item
      this.activeprovince='平均'
      this.getdatabyprovice()
    },
    // handleSelectv(key) {
    //   console.log(key);
    //   this.activevegetable = this.filteredVegetable[key];
    //   // this.linedata = this.allprovincesData[this.activeprovince].data;
    //   console.log(this.activevegetable)
    //   this.getdatabyprovice()
    // },
    changedata(){
      
      if(this.activeprovince in this.allprovincesData){
        this.linedata = this.allprovincesData[this.activeprovince].data;
      }
      else{
        console.log("无")
        this.linedata = []
      }
    },
    searchvegpro(){
    this.$axios.get("/api/getdatabyvpt/?type="+this.activevegetype+'&&vege='+this.searchVeg2+'&&pro='+this.searchPro2+'&&time'+this.dateList[0]+'-'+this.dateList[1]).then((res) => {
        console.log(res.data);
        this.searchdata=res.data
        this.params=[this.searchVeg2,this.searchPro2,this.dateList]
      });
  },
  exportExcel() {
      // 假设数据是一个二维数组，模拟表格数据
      var params=this.params
      var data=this.searchdata.map(item => [item['年份'], item['种类'], item['省份'],item['单位面积碳碳足迹'],item['单位产量碳碳足迹']]);
      // 创建一个工作簿对象
      console.log(XLSX)
      const workbook = XLSX.utils.book_new();
      // 将数据转换为工作表对象并添加到工作簿
      const worksheet = XLSX.utils.aoa_to_sheet(data);
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      // 将工作簿转换为二进制数据
      const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' });
      // 创建一个下载链接
      function s2ab(s) {
        let buf = new ArrayBuffer(s.length);
        let view = new Uint8Array(buf);
        for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
      }
      const blob = new Blob([s2ab(wbout)], { type: "application/octet-stream" });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = params[2][0]+"-"+params[2][1]+"年"+params[1]+"年"+params[0]+".xlsx";
      link.click();
    },
    beginDate() {
      let self = this
      return {
        disabledDate(time) {
          if (self.dateList[1] !== '') {
            let fixedTime = new Date(time)
            return fixedTime.getFullYear() > self.dateList[1]
          }
        }
      }
    },
    // 提出结束时间必须大于提出开始时间
    processDate() {
      let self = this
      return {
        disabledDate(time) {
          // let fixedTime = new Date(self.oldTime).getTime()
          // return time.getTime() < fixedTime
          let fixedTime = new Date(time)
          return fixedTime.getFullYear() < self.dateList[0]
        }
      }
    },

  },
  
};
</script>


<style>
.dataview {
  height: 100%;
  width: 100%;
  display: flex;
}
.dataview .left {
  margin-left: 10px;
   margin-top: 10px;
  width: 200px;
  display: flex;
  flex-direction: column;
  background-color: #f0f0f4;
  border-radius: 20px;
  /* box-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.5);  */
  padding: 10px;
  border: #cdcdcf 1px solid;
}
.dataview .left .el-input{
  width:180px;
}
.dataview .left_item{
  /* height: 40%; */
  height: 35vh !important;
  overflow-y: auto;
}
.dataview .left .el-menu-item {
display: flex !important;
justify-content: center;
align-items: center;
height: 40px !important;
width: 180px !important;
padding: 0 !important; 
}
.dataview .left .el-menu {
  width: 180px !important;
}
.dataview .el-menu-item-group__title{
  padding: 10px 0 !important;
  font-size: 12px;
  text-align: left;
}
.dataview .el-menu-item-group__title span{
  margin-left: 10px;
}
.rightline {
  flex:1;
  position: relative;
  padding: 20px;
}
.dataview .el-menu-item.is-active{
  background-color:  #fff !important;
  color: black !important;
}


</style>